import { render } from "./ShipmentListItem.vue?vue&type=template&id=23ebf31d&ts=true"
import script from "./ShipmentListItem.vue?vue&type=script&lang=ts"
export * from "./ShipmentListItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__